import { render } from "./other-products.vue?vue&type=template&id=3de4361d&scoped=true"
import script from "./other-products.vue?vue&type=script&lang=js"
export * from "./other-products.vue?vue&type=script&lang=js"

import "./other-products.vue?vue&type=style&index=0&id=3de4361d&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de4361d"]])

export default __exports__